import { render, staticRenderFns } from "./pro-section.vue?vue&type=template&id=68306c6a&scoped=true&"
import script from "./pro-section.vue?vue&type=script&lang=js&"
export * from "./pro-section.vue?vue&type=script&lang=js&"
import style0 from "./pro-section.vue?vue&type=style&index=0&id=68306c6a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68306c6a",
  null
  
)

export default component.exports